import { parseISO, format } from 'date-fns';

export const formatWeekKey = (key: string): string => {
    if (!key) return '';
    const [startStr, endStr] = key.split('_'); // "2025-12-04_2025-12-10"

    const start = parseISO(startStr);
    const end = parseISO(endStr);

    return `${format(start, 'd MMM')} - ${format(end, 'd MMM')}`;
    // e.g. "30 Nov - 6 Dec"
};

export const checkIfDateIsWeekKey = (key: string): boolean => {
  if (!key) return false;
  return key.includes('_');
}